import { render, staticRenderFns } from "./setting-base.vue?vue&type=template&id=2775e382&scoped=true&"
import script from "./setting-base.vue?vue&type=script&lang=ts&"
export * from "./setting-base.vue?vue&type=script&lang=ts&"
import style0 from "./setting-base.vue?vue&type=style&index=0&id=2775e382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2775e382",
  null
  
)

export default component.exports